export default {
  state: {
    settings: {
      data: [],
      search: '',
      page: 1,
      totalPages: 1,
      sort: {
        name: 1
      }
    }
  },
  getters: {
    getAllSettings: state => state.settings,
    getSettingsPage: state => state.settings.page,
    getSettingSearch: state => state.settings.search
  },
  mutations: {
    fillSettings (state, data) {
      state.settings.data = data
    },
    clearSettings (state) {
      state.settings.data = []
    },
    setSettingPage (state, page) {
      state.settings.page = page
    },
    setSettingsSort (state, sort) {
      state.settings.sort = sort
    },
    setSettingSearch (state, search) {
      state.settings.search = search
    }
  },
  actions: {
    fetchSettings ({commit, state, rootState}) {
      commit('setFetching', true)
      let query = {
        $skip: (state.settings.page - 1) * 10,
        $sort: state.settings.sort
      }
      if (state.settings.search.length) {
        query['orRegex'] = [
          {
            name: {
              $search: state.settings.search
            }
          }
        ]
      }
      rootState.services.settings.find({query}).then(result => {
        commit('fillSettings', result)
        commit('setFetching', false)
      })
    },
    saveSetting ({dispatch, commit, state, rootState}, data) {
      rootState.services.settings.create(data)
        .then(res => {
          dispatch('fetchSettings')
          commit('setSnack', {
            message: 'Operatiune reusita. Setare adaugata.',
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          error.meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', error)
        })
    },
    updateSetting ({dispatch, commit, state, rootState}, data) {
      rootState.services.settings.patch(data._id, data)
        .then(res => {
          dispatch('fetchSettings')
          commit('setSnack', {
            message: 'Operatiune reusita. Setare modificata.',
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          error.meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', error)
        })
    },
    deleteSetting ({dispatch, commit, state, rootState}, _ids) {
      rootState.services.settings.remove(null, {query: {_id: {$in: _ids}}})
        .then(res => {
          dispatch('fetchSettings')
          commit('setSnack', {
            message: `Operatiune reusita. ${res.length} setare(i) eliminata(e).`,
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          error.meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', error)
        })
    },
    setSettingPage ({commit, dispatch}, page) {
      commit('setSettingPage', page)
      dispatch('fetchSettings')
    },
    setSettingsSort ({commit, dispatch}, sort) {
      commit('setSettingsSort', sort)
      dispatch('fetchSettings')
    },
    setSettingSearch ({commit, dispatch}, search) {
      commit('setSettingSearch', search)
      dispatch('fetchSettings')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/settings.js